import { useEffect, useRef, useState } from 'react';
import './App.css';
import './css/global.css';
import SideMenu from './Component/SideMenu'

import ReactGA from 'react-ga';

import { isDesktop, isMobile, isTablet, useMobileOrientation } from 'react-device-detect';

import $ from "jquery";
import { Button, ButtonGroup, Alert, Intent } from '@blueprintjs/core';
import '@blueprintjs/core/lib/css/blueprint.css';

import PageContext from './Context/PageContext';
import Editor from './Component/Editor';
import EditorTopMenu from './Component/EditorTopMenu';
import Preview from './Component/Preview';
import AbsoluteMenuSection from './Section/AbsoluteMenuSection';
import Header from './Component/Header';
import { LoadTemplate, SaveTemplate } from './Util/SaveUtil';

import axios from 'axios';
import { CenterMapFromListPoint, CenterMapFromListTrace, calcElevationProfile } from './Util/ActivitesUtil';
import AlertMsg from './Component/AlertMsg';
import { ExportPdf } from './Util/ExportUtil';
import { fitZoom } from './Util/ZoomUtil';
import EditorBottomMenu from './Component/EditorBottomMenu';
import localforage from 'localforage';

//fonts
import "./fonts/edo.ttf"
import "./fonts/Bauhaus-93-Regular.ttf"
import "./fonts/coolvetica-rg.ttf"
import "./fonts/impact.ttf"
import "./fonts/Arial.ttf"
import "./fonts/Arial Black.ttf"
import "./fonts/Comic Sans MS.ttf"


import { useHistory } from './history/historyManager';

const l = document.getElementById('app') as HTMLElement;
const p = document.querySelector(".target2") as HTMLElement;

/* A METTRE DANS UN FICHIER DE CONF => fait à SUPPRIMER */
//const MIN_ZOOM = 0;
//const MAX_ZOOM = 2; //200%

function convertCanvasToImage() {
  let canvas = document.getElementsByClassName('mapboxgl-canvas')[0] as HTMLCanvasElement;
  let image = new Image();
  image.src = canvas.toDataURL();
  return image;
}

//init var globale
(window as any).$sources = [];
(window as any).$layers = [];

const queryParameters = new URLSearchParams(window.location.search);
const modeAdmin = queryParameters.get("modeAdmin") != null ? true : false;

function App() {

  var init_context: { objItems: any; pageSize: any; pageColor: any; mapPosition: any; mapIndex: any; mapTaille: any; mapUrlStyle: any; mapListPoint: any; mapListTrace: any; mapCenter: any, mapZoom: any } | null = null;

  const [objItems, setObjItems] = useState(() => { const data = init_context != null ? init_context.objItems : null; return data != null ? data : new Array(); });
  const [selectedItem, setSelectedItem] = useState(null);
  const [cropCadreImage, setCropCadreImage] = useState(null);
  const [cropImage, setCropImage] = useState(null);
  const [page, setPage] = useState(null);
  const [pageSize, setPageSize] = useState(() => { const data = init_context != null ? init_context.pageSize : null; return data != null ? data : { height: 1654, width: 1170 }; });
  const [pageColor, setPageColor] = useState(() => { const data = init_context != null ? init_context.pageColor : null; return data != null ? data : 'white' });
  const [zoomValue, setZoomValue] = useState(1);
  const [mapPosition, setMapPosition] = useState(() => { const data = init_context != null ? init_context.mapPosition : null; return data != null ? data : { x: 40, y: 40 }; });
  const [mapIndex, setMapIndex] = useState(() => { const data = init_context != null ? init_context.mapIndex : null; return data != null ? data : 0; });
  const [mapTaille, setMapTaille] = useState(() => { const data = init_context != null ? init_context.mapTaille : null; return data != null ? data : { height: 1200, width: 1090 }; });
  const [mapZoom, setMapZoom] = useState<number | null>(null);
  const [mapCenter, setMapCenter] = useState<any | null>(null);
  const [mapUrlStyle, setMapUrlStyle] = useState(() => { const data = init_context != null ? init_context.mapUrlStyle : null; return data != null ? data : 'mapbox://styles/mapbox/streets-v11' });
  const [mapLayers, setMapLayers] = useState(new Array());
  const [mapSources, setMapSources] = useState(new Array());
  const [mapListEtape, setMapListEtape] = useState(new Array());
  const [mapListPoint, setMapListPoint] = useState(() => { const data = init_context != null ? init_context.mapListPoint : null; return data != null ? data : new Array(); });
  const [mapListTrace, setMapListTrace] = useState(() => { const data = init_context != null ? init_context.mapListTrace : null; return data != null ? data : new Array(); });
  const [isDraggableMap, setIsDraggableMap] = useState(false);
  const [selectedItemIsLock, setSelectedItemIsLock] = useState(false);
  const [traceStyle, setTraceStyle] = useState({ "line-color": "black", "line-width": 7, "line-dasharray": [1] });
  const [traceLayout, setTraceLayout] = useState({ 'visibility': 'visible' });
  const [colorTextPicker, setColorTextPicker] = useState(null);
  const [imgUserList, setImgUserList] = useState(new Array());
  const [isOpenOpacity, setIsOpenOpacity] = useState(false);
  const [openAbsoluteMenuSection, setOpenAbsoluteMenuSection] = useState('');
  const [isMarqueurDepart, setIsMarqueurDepart] = useState(true);
  const [isMarqueurArrivee, setIsMarqueurArrivee] = useState(true);
  const [isMarqueurEtapes, setIsMarqueurEtapes] = useState(true);
  const [isAfficheNoms, setIsAfficheNoms] = useState(true);
  const [isAfficheNomsDefaut, setIsAfficheNomsDefaut] = useState(true);
  const [styleMarqueurDepart, setStyleMarqueurDepart] = useState({ "class": "marker-circle", "size": 20, "color": "black" });
  const [styleMarqueurArrivee, setStyleMarqueurArrivee] = useState({ "class": "marker-circle", "size": 20, "color": "black" });
  const [styleMarqueurEtapes, setStyleMarqueurEtapes] = useState({ "class": "marker-circle", "size": 20, "color": "black" });
  const [majDate, setMajDate] = useState('');
  const [time, setTime] = useState(0);
  const [isOpenAlert, setIsOpenAlert] = useState(false);
  const [elevationData, setElevationData] = useState(new Array());
  const [chartRef, setChartRef] = useState(null);
  const [isElevationPresent, setIsElevationPresent] = useState(false);
  const [isMode3D, setIsMode3D] = useState(false);
  const [afficheType, setAfficheType] = useState('print');
  const [isPortrait, setIsPortrait] = useState(true);
  const [jsonFormat, setJsonFormat] = useState({
    "id": "a4_page_print",
    "icon": "a4.svg",
    "text": "A4",
    "subtext": "21 x 29.7 cm",
    "size": {
      "height": 1654,
      "width": 1170
    },
    "price": "19",
    "attribute_support": "impression",
    "attribute_format": "a4-21x29-7cm"
  });
  const [openAlertMsg, setOpenAlertMsg] = useState(false);
  const [mapLock, setMapLock] = useState(false);

  /* API Data*/
  const [initFondCarte, setInitFondCarte] = useState(new Array());
  const [initModele, setInitModele] = useState(new Array());


  /* Use to not set localStorage at first load*/
  const [firstLoad, setFirstLoad] = useState(true);

  const [imgNameCompose, setImgNameCompose] = useState("");
  const [goCompose, setGoCompose] = useState(false);

  const [isOpenAlertExit, setIsOpenAlertExit] = useState(false);
  const popStateHandlerRef = useRef<(e: PopStateEvent) => void>();

  //Object.defineProperty(window, "devicePixelRatio", { get: function(){return 500 / 96; }});
  const { isLandscape } = useMobileOrientation();

  const history = useHistory();


  //solution de contournement pour avoir le live mapListPoint et mapListTrace
  //a priori, dans context, on ne devrait pas exporser les liste elle meme, mais des getters, on utilise des références mémoires
  //refs miroir
  const mapListPointRef = useRef<any[]>([]);
  const mapListTraceRef = useRef<any[]>([]);
  const selectItemRef = useRef<any>();

  useEffect(() => {
    mapListPointRef.current = mapListPoint;
  }, [mapListPoint]);

  useEffect(() => {
    mapListTraceRef.current = mapListTrace;
  }, [mapListTrace]);

  useEffect(() => {
    selectItemRef.current = selectedItem;
  }, [selectedItem]);

  // getters live
  const getMapListPoint = () => mapListPointRef.current;
  const getMapListTrace = () => mapListTraceRef.current;
  const getSelectedItem = () => selectItemRef.current;

  /*const addItem = (item: any) => {
    //setObjItems([...objItems, item]);
    setObjItems((prev: any) => [...prev, item]);

    //historique est gérer en dehors, pour éviter l'effet cyclique, et avoir des actions métiers bien séparées
  };*/

  //add or update item
  const addItem = (item: any) => {

    setObjItems((prev: any[]) => {
      const index = prev.findIndex(i => i.id === item.id);

      //l'item n'existe pas encore
      if (index === -1) {
        return [...prev, item];
      }

      //l'item existe → on le remplace
      const next = [...prev];
      next[index] = item;
      return next;
    });
  };

  /* Gestion où l'on ajoute des items sans rechargement (il ne restait que le dernier élément ajouté) 
  On passe un update dans le fonction set
  https://stackoverflow.com/questions/74862405/is-there-a-way-to-update-contexts-state-concurrently-from-multiple-components-i */
  const addMapSource = (item: any) => {
    setMapSources((mapSources) => [...mapSources, item]);
  };

  const addMapLayer = (item: any) => {
    setMapLayers((mapLayers) => [...mapLayers, item]);
  };

  const addMapListEtape = (item: any) => {
    setMapListEtape([...mapListEtape, item]);
  };

  const addMapListPoint = (items: any[]) => {
    //getMapListPoint() utilise la version actuelle, et pas une copie, un snapchot d'un moment donné.
    setMapListPoint([...getMapListPoint(), ...items]);

    var newMapListPoint = [...getMapListPoint(), ...items];

    /* center map */
    // on centre automatiquement sur les points, sauf:
    // - au premier chargement (car si on a des points stockés dans le localStorage alors center est aussi stocké)
    // - et si plus qu'un point, on le fait avec les tracés
    if (!firstLoad && newMapListPoint.length == 1) {
      CenterMapFromListPoint(newMapListPoint);
    }

  };

  const addMapListTrace = (items: any[],) => {
    //https://www.andreadiotallevi.com/blog/how-to-handle-multiple-set-state-calls-on-the-same-object-in-react
    setMapListTrace((mapListTrace: any) => ([...mapListTrace, ...items]));

    var newMapListTrace = [...mapListTrace, ...items];

    calcElevationProfile(newMapListTrace, setElevationData, elevationData, setIsElevationPresent,
      objItems, removeItem, setChartRef);

    if (!firstLoad) {
      CenterMapFromListTrace(newMapListTrace, mapLock);
    }

  };

  //méthode spécial pour SaveUtil, 
  //car quand on lit le localStorage on a besoin de elevationData directement dans la méthode sans attendre le rechargement
  const addMapListTraceSpecialFirtstLoad = (items: any[], elevationDataTmp: any) => {
    setMapListTrace([...mapListTrace, ...items]);
    var newMapListTrace = [...mapListTrace, ...items];
    calcElevationProfile(newMapListTrace, setElevationData, elevationDataTmp, setIsElevationPresent,
      objItems, removeItem, setChartRef);

    //CenterMapFromListTrace(newMapListTrace, mapLock);

  };

  const addImgUserList = (item: any) => {
    setImgUserList([...imgUserList, item]);
  };

  /* chaque nouvel élément se voit attribuer un id qui est l'id de HTMLElement pour selectedItem et id du JSON pour text items*/
  const removeItem = (id: any) => {
    setObjItems((oldValues: any[]) => {
      return oldValues.filter(itemToDelete => itemToDelete.id !== id)
    })
  };

  const removeMapSources = (id: any) => {
    setMapSources(oldValues => {
      return oldValues.filter(itemToDelete => itemToDelete.id !== id)
    })
  };

  const removeMapLayers = (id: any) => {
    setMapLayers(oldValues => {
      return oldValues.filter(itemToDelete => itemToDelete.id !== id)
    })
  };

  const removeMapListEtape = (id: any) => {
    setMapListEtape(oldValues => {
      return oldValues.filter(itemToDelete => itemToDelete.id !== id)
    })
  };

  const removeMapListPoint = (id: any, recalItineraire: boolean) => {
    setMapListPoint((oldValues: any) => {
      var newMapListTrace = oldValues.filter((itemToDelete: any) => itemToDelete.id !== id);
      /* center map */
      if (recalItineraire) CenterMapFromListPoint(newMapListTrace);

      return newMapListTrace;
    })
  };

  const removeMapListTrace = (ids: any[], recalItineraire: boolean) => {
    setMapListTrace((oldValues: any) => {

      //var newMapListTrace = oldValues.filter((itemToDelete: any) => itemToDelete.id !== id);
      var newMapListTrace = oldValues.filter((itemToDelete: any) => !ids.includes(itemToDelete.id));

      //remove map source and layer
      for (let id of ids) {
        removeMapSources(id);
        removeMapLayers(id);
      }

      calcElevationProfile(newMapListTrace, setElevationData, elevationData, setIsElevationPresent,
        objItems, removeItem, setChartRef);

      //recalItineraire est tjr à true, sauf quand on supprime tout pour refaire tous les tracés dans history
      if (recalItineraire) CenterMapFromListTrace(newMapListTrace, mapLock);

      return newMapListTrace;

      //return oldValues.filter((itemToDelete: any) => itemToDelete.id !== id)
    })
  };

  function loadModeleProduit(modeleProduct: any) {

    if (modeleProduct != null) {

      //var json = process.env.REACT_APP_URL_BACK + '/modeles-produit/' + modeleProduct.id + '/' + modeleProduct.file;

      var urlAPI = process.env.REACT_APP_URL_BACK + '/api/modele-produit-id/' + modeleProduct;

      axios(urlAPI)
        .then((res) => {

          var jsonLink = res.data.file;
          var json = process.env.REACT_APP_URL_BACK + "/" + jsonLink;

          axios(json)
            .then((resultat) => {

              LoadTemplate(resultat.data, {
                setObjItems, mapListPoint, addMapListPoint, mapListTrace,
                addMapSource, addMapLayer, traceStyle, traceLayout, addMapListTraceSpecialFirtstLoad, setPageSize,
                setPageColor, setMapPosition, setMapIndex, setMapTaille, setMapUrlStyle, setElevationData, setIsElevationPresent,
                setIsMode3D, setIsPortrait, setMapLock, setJsonFormat, setMapZoom, setMapCenter,
              }, true);
            }).catch(error => console.error(error));
        }).catch(error => console.error(error));

      setFirstLoad(false);

      return true;
    }

  }

  function loadModeleClient(modeleComposeFile: any, compose: boolean) {

    if (modeleComposeFile != null) {

      //changer le répertorie par un répertoire modeles-compose
      var jsonCompose = process.env.REACT_APP_URL_BACK + '/uploads/json/' + modeleComposeFile;

      if (jsonCompose != null) {

        axios(jsonCompose)
          .then(async (res) => {

            LoadTemplate(res.data, {
              setObjItems, mapListPoint, addMapListPoint, mapListTrace,
              addMapSource, addMapLayer, traceStyle, traceLayout, addMapListTraceSpecialFirtstLoad, setPageSize,
              setPageColor, setMapPosition, setMapIndex, setMapTaille, setMapUrlStyle, setElevationData, setIsElevationPresent,
              setIsMode3D, setIsPortrait, setMapLock, setJsonFormat, setMapZoom, setMapCenter,
            }, true);

            //normalement on peut l'utiliser plus tard le nom sera rechargé
            setImgNameCompose(modeleComposeFile.replace(".json", ".pdf"))

            //On décompose l'appel pour que les state soient rechargés
            if (compose) {
              setTimeout(() => {
                setGoCompose(true);
              }, 3000);
            }



          }).catch(error => console.error(error));
      }

      setFirstLoad(false);

      return true;
    }

  }

  function loadModeleCompose(jsonParam: any) {

    if (jsonParam != null) {

      //var json = process.env.REACT_APP_URL_BACK + '/modeles-produit/' + modeleProduct.id + '/' + modeleProduct.file;

      var urlAPI = process.env.REACT_APP_URL_BACK + '/api/modele-produit-id/' + jsonParam.idProduct;

      axios(urlAPI)
        .then((res) => {

          var jsonLink = res.data.file;
          var json = process.env.REACT_APP_URL_BACK + "/" + jsonLink;

          axios(json)
            .then(async (resultat) => {

              //update value in json product by data passed in params
              var tmpJson = resultat.data;
              //http://localhost:3000/studio?jsonCompose={"format" : "a4_page_print", "idProduct" : "5956", "data" : { "temps" : "3:32:16"} }
              var tmpObjItems = tmpJson["objItems"];

              for (var key in jsonParam.data) {
                //find key in json
                const itemToUpdate = tmpObjItems.find((item: any) => item.tags === key);
                //set value
                if (itemToUpdate != null) itemToUpdate.text = jsonParam.data[key];
              }

              LoadTemplate(tmpJson, {
                setObjItems, mapListPoint, addMapListPoint, mapListTrace,
                addMapSource, addMapLayer, traceStyle, traceLayout, addMapListTraceSpecialFirtstLoad, setPageSize,
                setPageColor, setMapPosition, setMapIndex, setMapTaille, setMapUrlStyle, setElevationData, setIsElevationPresent,
                setIsMode3D, setIsPortrait, setMapLock, setJsonFormat, setMapZoom, setMapCenter,
              }, true);

              //le temps que le template soit bien chargé (la fonction prend un timeout de 1.5s pour charger le tracé)
              await new Promise(r => setTimeout(r, 3000));

              console.log("modele loaded");

              //export pdf
              //on passe le format ici
              var out = ExportPdf(false, null, {
                objItems,
                selectedItem, setSelectedItem,
                mapListPoint, addMapListPoint,
                pageSize, jsonFormat: jsonParam.format, isPortrait, setIsPortrait,
                setIsImgPreview: null, setIsImgFinal: null, setImgFinal: null, imgElement: null, productName: "auto"
              });

            }).catch(error => console.error(error));
        }).catch(error => console.error(error));

      setFirstLoad(false);

      return true;
    }

  }

  function handleEnterKeyPress() {
    var contentArea = document.querySelector('.editor-container');

    contentArea!.addEventListener('keypress', keyPressFunction);
  }

  /* Ici on gère un content editable*/
  function keyPressFunction(event: any) {
    // enter keycode is 13
    if (event.keyCode == 13 && event.shiftKey == false) {
      document.execCommand('insertLineBreak')
      event.preventDefault()
    }
  }

  function confirmLoadModeleProduit() {
    setIsOpenAlert(false);
    var idProduct = queryParameters.get("productId");

    if (idProduct != null) {
      //var modeleProduct = initModeleProduitSection.find((x: any) => x.id_produit == idProduct);

      loadModeleProduit(idProduct);
    }

  }

  function confirmLoadLocalStorage() {
    setIsOpenAlert(false);

    /*
    //avec localstorage
    var init_context = JSON.parse(window.localStorage.getItem('affiche_map_context')!);
    if (init_context != null) {

      //exeptionnelle
      //if(init_context.elevationData != null) setElevationData(init_context.elevationData)

      LoadTemplate(init_context, {
        setObjItems, mapListPoint, addMapListPoint, mapListTrace,
        addMapSource, addMapLayer, traceStyle, traceLayout, addMapListTraceSpecialFirtstLoad, setPageSize,
        setPageColor, setMapPosition, setMapIndex, setMapTaille, setMapUrlStyle, setElevationData, setIsElevationPresent,
        setIsMode3D, setIsPortrait, setMapLock, setJsonFormat
      }, true);
    }

    setFirstLoad(false);*/

    //avec localforage
    localforage.getItem('affiche_map_context').then(function (value: any) {
      // This code runs once the value has been loaded
      // from the offline store.

      var init_context = JSON.parse(value);

      if (init_context != null) {

        //exeptionnelle
        //if(init_context.elevationData != null) setElevationData(init_context.elevationData)

        LoadTemplate(init_context, {
          setObjItems, mapListPoint, addMapListPoint, mapListTrace,
          addMapSource, addMapLayer, traceStyle, traceLayout, addMapListTraceSpecialFirtstLoad, setPageSize,
          setPageColor, setMapPosition, setMapIndex, setMapTaille, setMapUrlStyle, setElevationData, setIsElevationPresent,
          setIsMode3D, setIsPortrait, setMapLock, setJsonFormat, setMapZoom, setMapCenter,
        }, true);
      }

      setFirstLoad(false);

    }).catch(function (err) {
      // This code runs if there were any errors
      console.log(err);
    });

  }


  /* When App is load : only on refresh page, normally not when state update ?*/
  useEffect(() => {
    //fitZoom();
    handleEnterKeyPress();

    //setFirstLoad(false);

    /* fetch api data */
    fetch(process.env.REACT_APP_URL_BACK + '/api/fondcarte')
      .then(response => response.json())
      .then(data => { setInitFondCarte(data) })
      .catch(error => console.error(error));

    fetch(process.env.REACT_APP_URL_BACK + '/api/modele')
      .then(response => response.json())
      .then(data => { setInitModele(data) })
      .catch(error => console.error(error));

    /* Si on on a un idProduit et on charge le modele associé*/
    /* Ajouter algo si c'est on a déjà le produit dans le localstorage, ou proposer une popup pr choisir*/


    var idProductLocalStorage: string | null = null;
    var modeleProduct = null;
    const idProduct = queryParameters.get("productId");
    const jsonComposeData = queryParameters.get("jsonCompose");
    //open a json client stock in server
    const jsonClientFile = queryParameters.get("jsonClient");
    const jsonClientCompose = queryParameters.get("jsonClientCompose");

    //http://localhost:3000/studio?jsonCompose={"format" : "a4_page_print", "idProduct" : "5956", "data" : { "temps" : "3:32:16"}}
    //http://localhost:3000/studio?jsonCompose={%22format%22%20:%20%22a4_page_print%22,%20%22idProduct%22%20:%20%22596%22,%20%22data%22%20:%20{%20%22temps%22%20:%20%223:32:16%22}}

    //a supp
    /*if (idProduct != null) {
      modeleProduct = initModeleProduitSection.find((x: any) => x.id_produit == idProduct);
    }*/

    /* load Template from localStorage*/

    localforage.getItem('affiche_map_context').then(function (value: any) {
      // This code runs once the value has been loaded
      // from the offline store.

      var init_context = JSON.parse(value);
      if (init_context != null) {
        idProductLocalStorage = init_context.idProduct != null ? init_context.idProduct : null;
      }

      //si le meme produit est dans localStorage alors on charge localStorage OU pas de modele on charge localStorage
      //sinon si idProduct on charge le modele 
      //sinon on charge un modele defaut à definir
      //sinon aucun des cas précédent, on charge s'il y a un localStorage
      if (jsonComposeData != null) {
        var paramData = JSON.parse(decodeURIComponent(jsonComposeData))
        console.log(paramData)
        loadModeleCompose(paramData)
      }
      else if (jsonClientFile != null) {
        loadModeleClient(jsonClientFile, false)
      }
      else if (jsonClientCompose != null) {
        loadModeleClient(jsonClientCompose, true)
      }
      else if (idProduct != null && idProduct == idProductLocalStorage) {

        //open alert :
        setIsOpenAlert(true);

      }
      else if (idProduct != null) {
        loadModeleProduit(idProduct);
      }
      else if (init_context) {

        //exeptionnelle
        //if(init_context.elevationData != null) setElevationData(init_context.elevationData)

        LoadTemplate(init_context, {
          setObjItems, mapListPoint, addMapListPoint, mapListTrace,
          addMapSource, addMapLayer, traceStyle, traceLayout, addMapListTraceSpecialFirtstLoad, setPageSize,
          setPageColor, setMapPosition, setMapIndex, setMapTaille, setMapUrlStyle, setElevationData, setIsElevationPresent,
          setIsMode3D, setIsPortrait, setMapLock, setJsonFormat, setMapZoom, setMapCenter,
        }, true);

        setFirstLoad(false);
      }
      else {
        //on charge modele defaut
        setFirstLoad(false);
      }

    }).catch(function (err) {
      // This code runs if there were any errors
      console.log(err);
    });


    /*
        var init_context = JSON.parse(window.localStorage.getItem('affiche_map_context')!); 
        if (init_context != null) {
          idProductLocalStorage = init_context.idProduct != null ? init_context.idProduct : null;
        }
    
        //si le meme produit est dans localStorage alors on charge localStorage OU pas de modele on charge localStorage
        //sinon si idProduct on charge le modele 
        //sinon on charge un modele defaut à definir
        //sinon aucun des cas précédent, on charge s'il y a un localStorage
        if (jsonComposeData != null) {
          var paramData = JSON.parse(decodeURIComponent(jsonComposeData))
          console.log(paramData)
          loadModeleCompose(paramData)
        }
        else if (jsonClientFile != null) {
          loadModeleClient(jsonClientFile)
        }
        else if (idProduct != null && idProduct == idProductLocalStorage) {
    
          //open alert :
          setIsOpenAlert(true);
    
          /*LoadTemplate(init_context, {
            setObjItems, mapListPoint, addMapListPoint, mapListTrace,
            addMapSource, addMapLayer, traceStyle, traceLayout, addMapListTrace, setPageSize,
            setPageColor, setMapPosition, setMapTaille, setMapUrlStyle, setElevationData
          }, true);*/
    /*}
    else if (idProduct != null) {
      loadModeleProduit(idProduct);
    }
    else if (init_context) {

      //exeptionnelle
      //if(init_context.elevationData != null) setElevationData(init_context.elevationData)

      LoadTemplate(init_context, {
        setObjItems, mapListPoint, addMapListPoint, mapListTrace,
        addMapSource, addMapLayer, traceStyle, traceLayout, addMapListTraceSpecialFirtstLoad, setPageSize,
        setPageColor, setMapPosition, setMapIndex, setMapTaille, setMapUrlStyle, setElevationData, setIsElevationPresent,
        setIsMode3D, setIsPortrait, setMapLock
      }, true);

      setFirstLoad(false);
    }
    else {
      //on charge modele defaut
      setFirstLoad(false);
    }
      */

    const interval = setInterval(() => {
      /*console.log(mapListPoint)
      var exportJSON = SaveTemplate({ mapListPoint, objItems: objItems, pageSize, pageColor, mapPosition, mapTaille, mapUrlStyle, mapListTrace })

      window.localStorage.setItem('affiche_map_context', JSON.stringify(exportJSON));

      var lastMajDate = new Date().toLocaleDateString('fr-FR', { year: "numeric", month: "numeric", day: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit" }).replace(',', '');

      setMajDate(lastMajDate)*/

    }, 10000/*120000*/);

    /* To avoir multiple eventListener on keydown*/
    return () => {
      document.removeEventListener("keypress", keyPressFunction);
      clearInterval(interval);
    }
  }, [])

  //intercepter back button
  function handleExitCancel() {
    setIsOpenAlertExit(false)
  }

  function handleExitConfirm() {

    const handler = popStateHandlerRef.current;
    if (handler) {
      window.removeEventListener('popstate', handler);
    }

    // IMPORTANT : laisser le navigateur sortir
    //-2 car state init, puis nouveau state, donc 2 
    window.history.go(-2);
  }

  useEffect(() => {
    const handler = (e: PopStateEvent) => {
      window.history.pushState({ modal: true }, '');
      setIsOpenAlertExit(true);
    };

    popStateHandlerRef.current = handler;

    window.history.pushState({ modal: true }, '');
    window.addEventListener('popstate', handler);

    return () => {
      window.removeEventListener('popstate', handler);
    };
  }, []);

  useEffect(() => {


    const interval = setInterval(() => {
      setTime((time) => time + 1);
    }, 30000);

    //pas de sauvegarde à l'arrivée
    if (time > 0) {

      var exportJSON = SaveTemplate({ mapListPoint, objItems: objItems, pageSize, pageColor, mapPosition, mapIndex, mapTaille, mapUrlStyle, mapListTrace, elevationData, isMode3D, isPortrait, mapLock, jsonFormat })

      //window.localStorage.setItem('affiche_map_context', JSON.stringify(exportJSON));

      // The same code with localForage:
      localforage.setItem('affiche_map_context', JSON.stringify(exportJSON));

      //var lastMajDate = new Date().toLocaleDateString('fr-FR', { year: "numeric", month: "numeric", day: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit" }).replace(',', '');
      var lastMajDate = new Date().toLocaleTimeString('fr-FR', { hour: "2-digit", minute: "2-digit", second: "2-digit" }).replace(',', '');

      setMajDate(lastMajDate)

      return () => {
        clearInterval(interval);
      };
    }
  }, [time]);

  /**/ useEffect(() => {

    //calcElevationProfile(mapListTrace, setElevationData, elevationData);

    if (!firstLoad) {
      fitZoom({ setZoomValue, pageSize });
    }

  }, [firstLoad]);

  /* use a state to know when release composition/ExportPdf with all state loaded 
  setGoCompose to true after wait 3s*/
  useEffect(() => {

    if (goCompose) {

      //on utilise imgNameCompose pour garder la décision du nom lors 

      var out = ExportPdf(false, imgNameCompose, {
        objItems,
        selectedItem, setSelectedItem,
        mapListPoint, addMapListPoint,
        pageSize, jsonFormat, isPortrait, setIsPortrait,
        setIsImgPreview: null, setIsImgFinal: null, setImgFinal: null, imgElement: null, productName: "auto"
      });

      setGoCompose(false)
    }

  }, [goCompose]);

  //Google Analytics
  useEffect(() => {
    ReactGA.pageview(window.location.href);

    //on désactive la calcul des vh, pas sur qu'on en ai besoin...
    //setDocHeight();
  }, []);

  function setDocHeight() {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight / 100}px`);
    alert("toto")
  };

  window.addEventListener('resize', function () {
    //setDocHeight();

  });

  /* Gestion pixel ratio mobile
  On met 2 maximum pour la manipulation mobile
  */
  (window as any).$devicePixelRatioInitial = window.devicePixelRatio;
  if (isMobile) Object.defineProperty(window, "devicePixelRatio", { get: function () { return 2; } });
  ;

  const contextVar = {
    objItems,
    setObjItems,
    addItem,
    removeItem,
    cropCadreImage, setCropCadreImage,
    cropImage, setCropImage,
    selectedItem,
    setSelectedItem,
    selectedItemIsLock,
    setSelectedItemIsLock,
    page,
    setPage,
    pageSize,
    setPageSize,
    pageColor,
    setPageColor,
    zoomValue,
    setZoomValue,
    mapPosition, setMapPosition,
    mapIndex, setMapIndex,
    mapTaille, setMapTaille,
    mapZoom, setMapZoom,
    mapCenter, setMapCenter,
    mapUrlStyle, setMapUrlStyle,
    mapSources,
    mapLayers,
    mapListEtape,
    addMapSource,
    addMapLayer,
    setMapSources,
    setMapLayers,
    setMapListEtape,
    addMapListEtape,
    isDraggableMap,
    setIsDraggableMap,
    colorTextPicker,
    setColorTextPicker,
    traceStyle,
    setTraceStyle,
    traceLayout, setTraceLayout,
    imgUserList,
    addImgUserList,
    isOpenOpacity,
    setIsOpenOpacity,
    openAbsoluteMenuSection, setOpenAbsoluteMenuSection,
    removeMapSources, removeMapLayers, removeMapListEtape,
    isMarqueurDepart, setIsMarqueurDepart,
    isMarqueurArrivee, setIsMarqueurArrivee,
    isMarqueurEtapes, setIsMarqueurEtapes,
    isAfficheNoms, setIsAfficheNoms,
    isAfficheNomsDefaut, setIsAfficheNomsDefaut,
    styleMarqueurDepart, setStyleMarqueurDepart,
    styleMarqueurArrivee, setStyleMarqueurArrivee,
    styleMarqueurEtapes, setStyleMarqueurEtapes,
    mapListPoint, setMapListPoint, removeMapListPoint, addMapListPoint,
    mapListTrace, setMapListTrace, removeMapListTrace, addMapListTrace,
    majDate, setMajDate,
    modeAdmin,
    elevationData, setElevationData,
    chartRef, setChartRef,
    isElevationPresent, setIsElevationPresent,
    isMode3D, setIsMode3D,
    initFondCarte, setInitFondCarte,
    initModele, setInitModele,
    addMapListTraceSpecialFirtstLoad,
    afficheType, setAfficheType,
    isPortrait, setIsPortrait,
    jsonFormat, setJsonFormat,
    openAlertMsg, setOpenAlertMsg,
    mapLock, setMapLock,
    getMapListPoint, getMapListTrace, getSelectedItem,
    history,
  }

  return (
    <div className="App" id='app'>
      <PageContext.Provider value={contextVar}>
        <Alert
          cancelButtonText="Modèle par défaut"
          confirmButtonText="Reprendre où j'en étais !"
          icon="high-priority"
          intent={Intent.SUCCESS}
          isOpen={isOpenAlert}
          onCancel={confirmLoadModeleProduit}
          onConfirm={confirmLoadLocalStorage}
          canOutsideClickCancel={true}
          className="alert-modele"
        >
          <p>
            Il existe une version enregistrée dans votre navigateur. Souhaitez-vous la recharger ? Sinon le modèle par défaut sera chargé.
          </p>
        </Alert>
        <AlertMsg />
        <Header />
        <div className='body-app'>
          {(isDesktop || isTablet || (isMobile && isLandscape)) && <SideMenu />}
          <div className='main-editor'>
            <EditorTopMenu />
            <div className='editor-container' id="editor-container">
              {openAbsoluteMenuSection != '' && <AbsoluteMenuSection />}
              <Alert
                cancelButtonText="Rester !"
                confirmButtonText="Quitter"
                icon="high-priority"
                intent={Intent.SUCCESS}
                isOpen={isOpenAlertExit}
                onCancel={handleExitCancel}
                onConfirm={handleExitConfirm}
                canOutsideClickCancel={true}
                className="alert-modele"
              >
                <p>
                  Etes-vous sûr de vouloir quitter l'application ?
                </p>
              </Alert>
              <Editor></Editor>
              {<div className='editor-top-menu-right'>
                <button className="button1-icone" onClick={history.undo} disabled={!history.canUndo}>
                  <div className='svg-icone-button1'>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.33331 6.66479L3.03831 6.95979L2.74414 6.66479L3.03831 6.36979L3.33331 6.66479ZM7.49997 16.2481C7.38947 16.2481 7.28349 16.2042 7.20535 16.1261C7.12721 16.0479 7.08331 15.942 7.08331 15.8315C7.08331 15.721 7.12721 15.615 7.20535 15.5368C7.28349 15.4587 7.38947 15.4148 7.49997 15.4148V16.2481ZM7.20497 11.1265L3.03831 6.95979L3.62831 6.36979L7.79497 10.5365L7.20497 11.1265ZM3.03831 6.36979L7.20497 2.20312L7.79497 2.79313L3.62831 6.95979L3.03831 6.36979ZM3.33331 6.24813H12.0833V7.08146H3.33331V6.24813ZM12.0833 16.2481H7.49997V15.4148H12.0833V16.2481ZM17.0833 11.2481C17.0833 12.5742 16.5565 13.846 15.6188 14.7837C14.6812 15.7213 13.4094 16.2481 12.0833 16.2481V15.4148C13.1884 15.4148 14.2482 14.9758 15.0296 14.1944C15.811 13.413 16.25 12.3532 16.25 11.2481H17.0833ZM12.0833 6.24813C13.4094 6.24813 14.6812 6.77491 15.6188 7.71259C16.5565 8.65027 17.0833 9.92204 17.0833 11.2481H16.25C16.25 10.1431 15.811 9.08325 15.0296 8.30185C14.2482 7.52044 13.1884 7.08146 12.0833 7.08146V6.24813Z" fill="currentColor" /></svg>
                  </div>
                </button>
                <button className="button1-icone" onClick={history.redo} disabled={!history.canRedo}>
                  <div className='svg-icone-button1'>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.6667 6.66479L16.9617 6.95979L17.2559 6.66479L16.9617 6.36979L16.6667 6.66479ZM12.5 16.2481C12.6105 16.2481 12.7165 16.2042 12.7947 16.1261C12.8728 16.0479 12.9167 15.942 12.9167 15.8315C12.9167 15.721 12.8728 15.615 12.7947 15.5368C12.7165 15.4587 12.6105 15.4148 12.5 15.4148V16.2481ZM12.795 11.1265L16.9617 6.95979L16.3717 6.36979L12.205 10.5365L12.795 11.1265ZM16.9617 6.36979L12.795 2.20312L12.205 2.79313L16.3717 6.95979L16.9617 6.36979ZM16.6667 6.24813H7.91669V7.08146H16.6667V6.24813ZM7.91669 16.2481H12.5V15.4148H7.91669V16.2481ZM2.91669 11.2481C2.91669 12.5742 3.44348 13.846 4.38116 14.7837C5.31884 15.7213 6.59061 16.2481 7.91669 16.2481V15.4148C6.81162 15.4148 5.75182 14.9758 4.97042 14.1944C4.18901 13.413 3.75003 12.3532 3.75003 11.2481H2.91669ZM7.91669 6.24813C6.59061 6.24813 5.31884 6.77491 4.38116 7.71259C3.44348 8.65027 2.91669 9.92204 2.91669 11.2481H3.75003C3.75003 10.1431 4.18901 9.08325 4.97042 8.30185C5.75182 7.52044 6.81162 7.08146 7.91669 7.08146V6.24813Z" fill="currentColor" /></svg>
                  </div>
                </button>
                {/*<ButtonGroup>
                  <Button small={true} disabled={!history.canUndo} className='button-editor-bottom' onClick={history.undo} icon="undo" />
                  <Button small={true} disabled={!history.canRedo} className='button-editor-bottom' onClick={history.redo} icon="redo" />
                </ButtonGroup>*/}
              </div>}

              {(isDesktop || isTablet || (isMobile && isLandscape)) && <EditorBottomMenu></EditorBottomMenu>}
            </div>

          </div>
          {isMobile && !isTablet && !isLandscape && <EditorBottomMenu></EditorBottomMenu>}
          {isMobile && !isTablet && !isLandscape && <SideMenu />}

        </div>
      </PageContext.Provider>
    </div>
  );
}

export default App;
